import { render, staticRenderFns } from "./CaseHandle.vue?vue&type=template&id=7d85cddf&scoped=true&"
import script from "./CaseHandle.vue?vue&type=script&lang=js&"
export * from "./CaseHandle.vue?vue&type=script&lang=js&"
import style0 from "./CaseHandle.vue?vue&type=style&index=0&id=7d85cddf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d85cddf",
  null
  
)

export default component.exports